import React, { useEffect,useState }  from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {getActivo} from '../../../redux/actions/mobiliarioactions';
import MyButton from '../../../utils/MyButton';
import { FaFileMedical,FaArrowCircleLeft,FaCogs,FaFilePdf, FaPhoneSquareAlt, FaRegCalendarCheck, FaRocket, FaSortDown, FaSortUp, FaThermometerHalf, FaWrench} from "react-icons/fa";
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccesoriosActivo from './AccesoriosActivo';
import AdjuntarDocActivo from './AdjuntarDocActivo';
import DetallesActivo from './DetallesActivo';
import ProgramarMtoActivoPerfil from './ProgramarMtoActivoPerfil';
import ProgramarCalActivoPerfil from './ProgramarCalActivoPerfil';
import SolicitudCorrectivoActivo from './SolicitudCorrectivoActivo';
import EstadoActivo from './EstadoActivo';
import BorrarActivo from './BorrarActivo';
import PerfilMobiliarioMtoProg from './PerfilMobiliarioMtoProg';
import './PerfilMobiliaro.css';
import PerfilMobiliarioMtoPrev from './PerfilMobiliarioMtoPrev';
import PerfilMobiliarioCalProg from './PerfilMobiliarioCalProg';
import PerfilMobiliarioCalReal from './PerfilMobiliarioCalReal';
import PerfilMobiliarioSolicitudes from './PerfilMobiliarioSolicitudes';
import PerfilMobiliarioCorrectivos from './PerfilMobiliarioCorrectivos';
function PerfilMobiliaro({ getActivo, dataMob, match }) {

  const history = useHistory();
  const [accion, setAccion] = useState(null);
  useEffect(() => {
    console.log(match.params.mobiliarioId);
    getActivo(match.params.mobiliarioId);
  }, [getActivo, match.params.mobiliarioId]);
  const { mobiliario, loadingdata } = dataMob;

  const [perfilInfoVisible, setPerfilInfoVisible] = useState(false); // Estado para controlar la visibilidad
  
    const [mostrarComponente, setMostrarComponente] = useState(false); // Estado para controlar la visibilidad del componente
  
  const handleVolverClick = () => {
    history.goBack();
};     
const toggleAccion = (nuevaAccion) => {
  if (nuevaAccion === accion && mostrarComponente) {
    // Si se hace clic en el botón que ya está seleccionado y el componente está visible, ocultarlo
    setAccion("");
    setMostrarComponente(false);
  } else {
    setAccion(nuevaAccion);
    setMostrarComponente(true);
  }
};
    

let cargarActivo= !loadingdata && mobiliario.credentials ? (
            <div className="equipment-card">
                <div className="equipment-card__content">
                  
                  <div className='equipment-img__container'>
                  
                <div className="div-imagencliente">
                <img
                src={
                  mobiliario.credentials.imagenurl === undefined || mobiliario.credentials.imagenurl === "undefined"
                    ? 'https://firebasestorage.googleapis.com/v0/b/alphaplatform.appspot.com/o/noImg.png?alt=media'
                    : mobiliario.credentials.imagenurl
                }
                alt="mobiliario"
                className="img-cliente"
              />
             
                </div>

                </div>
    
                <div className="equipment-card__info">
                <div className="div-titulocliente">
           
                <h3 className="text-titulo-cliente">{mobiliario.credentials.nombre}</h3>
                <p className="perfilequipo-text">{mobiliario.credentials.estado}</p>
                <p className="perfilequipo-text">{mobiliario.credentials.idinventario}</p>
                <AccesoriosActivo clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>
                               
                </div>
                

                <div className="div-equipo-info">
                <div className="div-perfil-info">
                <hr className="clientes_separator"></hr>  
                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Marca: </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.marca}</p>
                </div>
                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Modelo: </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.modelo}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Serie </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.serie}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Ubicación</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.ubicacion}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Servicio</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.servicio}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Equipo</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.movilfijo}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Tipo </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.tipo}</p>
                </div>

                <div className="div-perfil-detalle">
                  <h5 className="equipo-detalle">Tipo Uso</h5>    
                  <p className="perfilequipo-text">
                    {mobiliario?.credentials?.tipouso ?? "No registra"}
                  </p>
                </div>

            
                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Requiere Calibración </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.reqcalibracion=="true"?("Si"):("No")}</p>
                </div>

                 </div>

          
                 <div className="div-perfil-info" style={{ display: perfilInfoVisible ? 'flex' : 'none' }}>
                <hr className="clientes_separator"></hr>  
                
                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Forma de Adquisición </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.adquisicion}</p>
                </div>     

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Costo </h5>    
                <p className="perfilequipo-text">${mobiliario.credentials.costo}</p>
                </div>        

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Vida Util </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.vidautil} años</p>
                </div>        

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Fecha de Fabricación </h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.fabricacion}</p>
                </div>   
                
                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Fecha de Adquisición</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.fechaadquisicion}</p>
                </div>   

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Fecha de Instalación</h5>    
                <p className="perfilequipo-text"> {mobiliario?.credentials?.fechainstalacion ?? "No registra"}</p>
                </div>

                <div className="div-perfil-detalle">
                    <h5 className="equipo-detalle">Equipo en Garantía </h5>    
                    <p className="perfilequipo-text">
                      {mobiliario?.credentials?.garantia === "true" 
                        ? (new Date() > new Date(mobiliario?.credentials?.fechafingarantia) 
                            ? "Sí (VENCIDA)" 
                            : "Sí")
                        : "No"}
                    </p>
                    </div>

                    {mobiliario?.credentials?.garantia === "true" && (
                      <>
                        <div className="div-perfil-detalle">
                        <h5 className="equipo-detalle">Fecha Inicio Garantía</h5>    
                        <p className="perfilequipo-text"> {mobiliario?.credentials?.fechainiciogarantia ?? "No registra"}</p>
                        </div>

                        <div className="div-perfil-detalle">
                        <h5 className="equipo-detalle">Fecha Fin Garantía</h5>    
                        <p className={`perfilequipo-text ${new Date() > new Date(mobiliario?.credentials?.fechafingarantia) ? "text-danger" : ""}`}>
                          {mobiliario?.credentials?.fechafingarantia ?? "No registra"}
                          {new Date() > new Date(mobiliario?.credentials?.fechafingarantia) ? " (VENCIDA)" : ""}
                        </p>
                        </div>
                      </>
                    )}

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Pais Fabricante</h5>    
                <p className="perfilequipo-text"> {mobiliario?.credentials?.pais ?? "No registra"}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Nombre Fabricante</h5>    
                <p className="perfilequipo-text"> {mobiliario?.credentials?.nombrefabricante ?? "No registra"}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Telefono Fabricante</h5>    
                <p className="perfilequipo-text"> {mobiliario?.credentials?.telfabricante ?? "No registra"}</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Email Fabricante</h5>    
                <p className="perfilequipo-text"> {mobiliario?.credentials?.emailfabricante ?? "No registra"}</p>
                </div>


                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Proveedor</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.proveedor}</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">E-mail</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.proveedoremail}</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Teléfono</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.proveedortel}</p>
                </div>  

                </div>


                <div className="div-perfil-info" style={{ display: perfilInfoVisible ? 'flex' : 'none' }}>
                <hr className="clientes_separator"></hr>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Tipo de Tecnología</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.tipotec}</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Fuente de Alimentación</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.fuente}</p>
                </div> 

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Link del Manual</h5>    
                <p className="perfilequipo-text">{!mobiliario.credentials.urlmanual?<a>Sin Manual Adjunto</a>:<a href={mobiliario.credentials.urlmanual} target="_blank" rel="noopener noreferrer">Link del Manual</a>}</p>
                </div> 

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Link del Manual Usuario</h5>    
                <p className="perfilequipo-text">{!mobiliario.credentials.urlmanualuser?<a>Sin Manual Usuario Adjunto</a>:<a href={mobiliario.credentials.urlmanualuser} target="_blank" rel="noopener noreferrer">Link del Manual</a>}</p>
                </div> 

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Link de Factura</h5>    
                <p className="perfilequipo-text">{!mobiliario.credentials.urlfactura?<a>Sin Factura Adjunta</a>:<a href={mobiliario.credentials.urlfactura} target="_blank" rel="noopener noreferrer">Link de la Factura</a>}</p>
                </div> 

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Link Importación</h5>    
                <p className="perfilequipo-text">{!mobiliario.credentials.urlimportacion?<a>Sin Importacion Adjunta</a>:<a href={mobiliario.credentials.urlimportacion} target="_blank" rel="noopener noreferrer">Link de la Factura</a>}</p>
                </div> 

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Tensión Min</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.tensionmin} V</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Tensión Max</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.tensionmax} V</p>
                </div> 

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Corriente Min</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.corrientemin} A</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Corriente Max</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.corrientemax} A</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Potencia</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.potencia} W</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Temperatura</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.temperatura} °C</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Capacidad</h5>    
                <p className="perfilequipo-text"> {mobiliario?.credentials?.capacidad ?? "No registra"} m3</p>
                </div>

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Velocidad</h5>    
                <p className="perfilequipo-text"> {mobiliario?.credentials?.velocidad ?? "No registra"} m/s</p>
                </div>


                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Frecuencia</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.frecuencia} °C</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Presión</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.presion}</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Alto</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.alto} cm</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Ancho</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.ancho} cm</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Largo</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.largo} cm</p>
                </div>  

                <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Peso</h5>    
                <p className="perfilequipo-text">{mobiliario.credentials.peso} Kg</p>
                </div>  

                </div>


               </div>
                </div>
                </div>

                <div className="equipment-card__actions">
                <AdjuntarDocActivo clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId} />
                 <DetallesActivo clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>
               <ProgramarMtoActivoPerfil clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>
               <ProgramarCalActivoPerfil clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>
                    <SolicitudCorrectivoActivo clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>                          
                    <EstadoActivo clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>    
                    <BorrarActivo clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId} history={history}/>                                                
                    <Link to={`/dashboard/perfilcliente/mobiliario/${match.params.clienteId}/${match.params.mobiliarioId}/hojadevidapdf`} className="text-link-inventariopdf">
                    <MyButton tip="Hoja de Vida PDF">
                    <FaFilePdf color="#03178C" className="icon-crearcliente"/>
                    </MyButton>
                    </Link>
                    <MyButton tip="Mostrar Más" onClick={() => setPerfilInfoVisible(!perfilInfoVisible)}>
                        {perfilInfoVisible ? ( // Mostrar un icono cuando perfilInfoVisible es true
                            <FaSortUp color="#03178C" className="icon-crearcliente" />
                        ) : ( // Mostrar otro icono cuando perfilInfoVisible es false
                            <FaSortDown color="#03178C" className="icon-crearcliente" />
                        )}
                    </MyButton> 
                    
                </div>
             
            </div>

            
            )
            
            :(<div className="div_cargando"><CircularProgress size={50}color="primary" className="login-progress" /></div>);
          
  return (
    <div>
      <div className="titulo_section">
                    <div className="titulo_clientes">
                    <h1 className="text-clientes">Perfil de Activo</h1>
                    <hr className="clientes_separator"></hr>            
                    
                    </div>
    
                    <div className="div_boton">
                      <MyButton tip="Volver" onClick={handleVolverClick}>
                        <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
                      </MyButton>
                    </div>
                    </div>
                    {cargarActivo}

                    <div className='equipment-actions-grid'>
        <Button
            variant="contained"
            endIcon={<FaWrench style={{ color: accion === "MtosProg" ? "white" : "#03178c" }} />}
            onClick={() => toggleAccion("MtosProg")}
            style={{
                backgroundColor: accion === "MtosProg" ? "#0588FB" : "initial",
                color: accion === "MtosProg" ? "white" : "#03178c",
                marginRight:accion === "MtosProg" ? "10px" : "10px",
                textTransform: accion === "MtosProg" ? "initial" : "initial"
                
            }}
            >
            {accion === "MtosProg" ? "Mtos Programados" : "Mtos. Programados"}
            </Button>
        <Button
          variant="contained"
          endIcon={<FaRocket  style={{ color: accion === "MtosReal" ? "white" : "#03178c" }} />}
          onClick={() => toggleAccion("MtosReal")} // Actualizar el estado al hacer clic en "MtosReal"
          style={{
            backgroundColor: accion === "MtosReal" ? "#0588FB" : "initial",
            color: accion === "MtosReal" ? "white" : "#03178c",
            marginRight:accion === "MtosReal" ? "10px" : "10px",
            textTransform: accion === "MtosReal" ? "initial" : "initial"
            
        }}
        >
          {accion === "MtosReal" ? "Mtos. Realizados" : "Mtos. Realizados"}
        </Button>

        <Button
          variant="contained"
          endIcon={<FaRegCalendarCheck  style={{ color: accion === "CalProg" ? "white" : "#03178c" }} />}
          onClick={() => toggleAccion("CalProg")} // Actualizar el estado al hacer clic en "CalProg"
          style={{
            backgroundColor: accion === "CalProg" ? "#0588FB" : "initial",
            color: accion === "CalProg" ? "white" : "#03178c",
            marginRight:accion === "CalProg" ? "10px" : "10px",
            textTransform: accion === "CalProg" ? "initial" : "initial"
            
        }}
        >
          {accion === "CalProg" ? "Cal. Programadas" : "Cal. Programadas"}
        </Button>

        <Button
          variant="contained"
          endIcon={<FaThermometerHalf  style={{ color: accion === "CalReal" ? "white" : "#03178c" }} />}
          onClick={() => toggleAccion("CalReal")}// Actualizar el estado al hacer clic en "CalReal"
          style={{
            backgroundColor: accion === "CalReal" ? "#0588FB" : "initial",
            color: accion === "CalReal" ? "white" : "#03178c",
            marginRight:accion === "CalReal" ? "10px" : "10px",
            textTransform: accion === "CalReal" ? "initial" : "initial"
            
        }}
        >
          {accion === "CalReal" ? "Cal. Realizadas" : "Cal. Realizadas"}
        </Button>

        <Button
          variant="contained"
          endIcon={<FaCogs  style={{ color: accion === "MtosCorr" ? "white" : "#03178c" }} />}
          onClick={() => toggleAccion("MtosCorr")} // Actualizar el estado al hacer clic en "MtosCorr"
          style={{
            backgroundColor: accion === "MtosCorr" ? "#0588FB" : "initial",
            color: accion === "MtosCorr" ? "white" : "#03178c",
            marginRight:accion === "MtosCorr" ? "10px" : "10px",
            textTransform: accion === "MtosCorr" ? "initial" : "initial"
            
        }}
        >
          {accion === "MtosCorr" ? "Mtos. Correctivos" : "Mtos. Correctivos"}
        </Button>

        <Button
          variant="contained"
          endIcon={<FaPhoneSquareAlt  style={{ color: accion === "SolCorr" ? "white" : "#03178c" }} />}
          onClick={() => toggleAccion("SolCorr")} // Actualizar el estado al hacer clic en "SolCorr"
          style={{
            backgroundColor: accion === "SolCorr" ? "#0588FB" : "initial",
            color: accion === "SolCorr" ? "white" : "#03178c",
            marginRight:accion === "SolCorr" ? "10px" : "10px",
            textTransform: accion === "SolCorr" ? "initial" : "initial"
            
        }}
        >
          {accion === "SolCorr" ? "Sol. Correctivos" : "Sol. Correctivos"}
        </Button>

      
      </div>

      <div className="acordion-container-equipo">
              {mostrarComponente && (
                  <div>
      
                   <div>
                   {accion === "MtosProg" ? <div>
                  <PerfilMobiliarioMtoProg clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId} />
                               
                  </div> : null}
                   </div>
      
                  <div>
                  {accion === "MtosReal" ? <div>
                  <PerfilMobiliarioMtoPrev clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId} />
                   </div> : null}
                  </div>
      
                  <div>
                  {accion === "CalProg" ? <div>
                    <PerfilMobiliarioCalProg clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId} />
                  
                    </div> : null}
                  </div>
      
                  <div>
                    {accion === "CalReal" ? <div>
                      <PerfilMobiliarioCalReal clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId} />
                  
                    </div> : null}
                  </div>
      
                  <div>
                    {accion === "MtosCorr" ? <div>
                      <PerfilMobiliarioCorrectivos clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>
                   
                    </div> : null}
                  </div>
      
                  <div>
                    {accion === "SolCorr" ? <div>
                    <PerfilMobiliarioSolicitudes clienteId={match.params.clienteId} mobiliarioId={match.params.mobiliarioId}/>
                    </div> : null}
                  </div>
      
      
                 </div>
      
              )}
             
            </div>
                    
    </div>
  )
}


PerfilMobiliaro.propTypes = {
  getActivo: PropTypes.func.isRequired,
  dataMob: PropTypes.object.isRequired
};

const mapActionsToProps = { getActivo };

const mapStateToProps = (state) => ({
  dataMob: state.dataMob,
});

export default connect(mapStateToProps, mapActionsToProps)(PerfilMobiliaro);

